module.exports = __webpack_public_path__ + "zvetseni-prsou_12_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_12_after.jpg
// module id = 1297
// module chunks = 0